import React, { useEffect, useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  Box,
  IconButton,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import TextContainerField from "../../../../components/TextContainerField";
import { ArrowBack } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import { fetchDataById } from "../../../../api/Services";
import Spinner from "../../../../components/Spinner";

const ViewMotorModel = () => {
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [modelData, setModelData] = useState(null);
  console.log("modelData", modelData);

  useEffect(() => {
    const fetchData = async () => {
      const paramId = params.id;

      if (paramId) {
        setIsLoading(true);
        try {
          await fetchDataById(`/reference/motor/mmv/model/${paramId}`).then(
            (res) => {
              console.log("rees", res);
              setModelData(res?.data);
            }
          );
        } catch (err) {
          console.log(err);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchData();
  }, [params.id]);

  if (isLoading) {
    return (
      <DashboardLayout>
        <Spinner />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Box
        sx={{
          padding: { xs: 2, md: 2 },
          bgcolor: "#f9f9f9",
          minHeight: "100vh",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="left"
          spacing={1}
          mb={2}
        >
          <IconButton onClick={() => window.history.back()}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
            Motor Model Information
          </Typography>
        </Stack>

        {modelData ? (
          <Grid container spacing={3} sx={{ mx: { xs: 0, md: 2 } }}>
            <Grid xs={12} sm={6} md={4} sx={{ width: "100%" }}>
              <Card sx={{ boxShadow: 3, borderRadius: 2, bgcolor: "white" }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: "600" }}>
                    {modelData?.make?.name}
                  </Typography>
                  <TextContainerField
                    label="Vehicle Category ID"
                    value={modelData?.motorCategoryId}
                  />
                  {/* <TextContainerField
                    label="IPL Make ID"
                    value={modelData?.iplMakeId}
                  /> */}
                  <TextContainerField
                    label="Motor Make ID"
                    value={modelData?.motorMakeId}
                  />
                  <TextContainerField
                    label="Status"
                    value={modelData?.isActive ? "Active" : "Inactive"}
                  />
                  <TextContainerField
                    label="Created By"
                    value={modelData?.createdBy}
                  />
                  <TextContainerField
                    label="Created At"
                    value={modelData?.createdAt}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        ) : (
          <Box>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                color: "red",
                fontFamily: "cursive",
              }}
            >
              No Motor Model Data Found
            </Typography>
          </Box>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default ViewMotorModel;
